var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 14,
    viewBox: "0 0 22 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5 7C21.5 6.80109 21.421 6.61032 21.2803 6.46967C21.1397 6.32902 20.9489 6.25 20.75 6.25H3.0605L7.781 1.531C7.85073 1.46127 7.90604 1.37849 7.94378 1.28738C7.98152 1.19627 8.00095 1.09862 8.00095 1C8.00095 0.901385 7.98152 0.803735 7.94378 0.712626C7.90604 0.621517 7.85073 0.538733 7.781 0.469001C7.71127 0.399269 7.62848 0.343955 7.53737 0.306216C7.44626 0.268478 7.34861 0.249054 7.25 0.249054C7.15138 0.249054 7.05373 0.268478 6.96262 0.306216C6.87151 0.343955 6.78873 0.399269 6.719 0.469001L0.718998 6.469C0.649153 6.53867 0.593739 6.62143 0.555929 6.71255C0.518119 6.80367 0.498657 6.90135 0.498657 7C0.498657 7.09865 0.518119 7.19633 0.555929 7.28745C0.593739 7.37857 0.649153 7.46133 0.718998 7.531L6.719 13.531C6.78873 13.6007 6.87151 13.656 6.96262 13.6938C7.05373 13.7315 7.15138 13.7509 7.25 13.7509C7.34861 13.7509 7.44626 13.7315 7.53737 13.6938C7.62848 13.656 7.71127 13.6007 7.781 13.531C7.85073 13.4613 7.90604 13.3785 7.94378 13.2874C7.98152 13.1963 8.00095 13.0986 8.00095 13C8.00095 12.9014 7.98152 12.8037 7.94378 12.7126C7.90604 12.6215 7.85073 12.5387 7.781 12.469L3.0605 7.75H20.75C20.9489 7.75 21.1397 7.67098 21.2803 7.53033C21.421 7.38968 21.5 7.19891 21.5 7Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.7769c2c0f3d8e04cb356d08d0e549a12.svg";
export { ForwardRef as ReactComponent };